import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UpdateApplication } from '../details/update-application';
import { CustomerInfo } from '../customer-info';
import { CustomerApplication } from '../customer-application';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { RestAPIService } from '../shared/shared-service/restAPI.service';
import { SharedDataService } from '../shared/shared-data/shared-data.service';
import swal from 'sweetalert2';


@Component({
  selector: 'app-applications',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.scss']
})
export class ApplicationsComponent implements OnInit {
  bsModalRef: BsModalRef;
  updateApp: UpdateApplication = new UpdateApplication();
  customerInfo: CustomerInfo;
  firmId: string;
  customerApplications: CustomerApplication[];
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<CustomerApplication> = new Subject();
  constructor(private modalService: BsModalService,
    private router: Router, private restAPIService: RestAPIService,
    private sharedDataService: SharedDataService) {

    this.dtOptions = {
      pagingType: 'full_numbers',
      paging: true,
      'pageLength': 5,
      'lengthMenu': [5, 10, 25, 50, 75, 100],
      'columnDefs': [
        { 'orderable': false, 'targets': 3 }]
    };
  }

  ngOnInit() {
    this.getApplications();
  }
  getApplications() {
    this.restAPIService.getApplications().
      then(applications => { this.customerApplications = applications; this.dtTrigger.next(); }).catch(error => {
        this.sharedDataService.showError(error.message);
      });
  }

  gotoRegister(): void {
    this.router.navigate(['/layout/register']);
  }
  goDetails(customerApplication: CustomerApplication): void {
    this.sharedDataService.saveCustomerApplication(customerApplication);
    this.router.navigate(['/layout/details']);
  }
  update(application: CustomerApplication): void {
    if (application.isEnabled) {

      this.updateApp.isEnabled = false;
    } else {

      this.updateApp.isEnabled = true;
    }
    this.restAPIService.updateApplication(this.updateApp, application.id).then(customerApplication => {
      application.isEnabled = customerApplication.isEnabled;
    }).catch(error => {
      this.sharedDataService.showError(error.message);
    });
  }
  deleteApplication(id: number): void {
    swal({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      width: 'auto',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(any => {
      this.deleteApp(id);
    }, dismiss => {
    })
  }

  deleteApp(id: number) {
    this.restAPIService.deleteApplication(id).then(any => { this.router.navigate(['/app']) }).catch(error => {
      this.sharedDataService.showError(error.message);
    });
  }
}
